import { faFolderOpen } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { EmptyStateIcon } from 'components/atoms/empty-state';
import { RoutePaths } from 'constant';
import { EmptyState, EmptyStateContainer } from './styles';

export const DrawerEmptyState: FC = () => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faFolderOpen} />}
        title={
          <FormattedMessage id="projects.task_template.drawer.empty_title" />
        }
        message={
          <FormattedMessage id="projects.task_template.drawer.empty_description" />
        }
        primaryCTA={
          <Link
            component={EmptyState.CallToAction.Secondary}
            to={RoutePaths.projectTemplateRoot}
          >
            <FormattedMessage id="projects.task_template.drawer.empty_cta" />
          </Link>
        }
      />
    </EmptyStateContainer>
  );
};
